<template>
   <div class="modal-info-user">
      <div class="header-modal mb-0">
         <h4 class="bg-facebook">
            <i class="el-icon-info mb-0 mr-1"></i>
            <span v-if="isRequestedByOwner">Informações para locação</span>
            <span v-else>Complete suas informações</span>

         </h4>
      </div>
      <div  class="pl-0 pr-0">
         <b-card
            class="border-0"
            border-variant="0"
         >
            <el-form
               v-show="checkout.billingInfo"
               :model="userInfoForm"
               :rules="userInfoFormRules"
               ref="userInfoForm"
               size="mini"
               v-loading="loading.userData"
               element-loading-text="Processando..."
            >

               <el-row v-if="isRequestedByOwner" class="mt-0 mb-3" :gutter="0">
                  <el-col :span="24">
                     <el-alert
                        v-if="foundUser === null"
                        type="warning"
                        effect="dark"
                        :title="`Atenção: Você está alugando a sua bicicleta ${selectedBike.info.name} para um ciclista.`">
                        Digite o CPF ou o e-mail do ciclista e aguarde uns instantes para identificar se já existe um cadastro. Caso ele não esteja cadastrado na plataforma, informe os dados para o cadastramento.
                     </el-alert>
                     <el-alert
                        show-icon
                        :closable="false"
                        v-if="foundUser === false"
                        type="error"
                        effect="dark"
                        title="Ciclista não cadastrado. Preencha os dados do ciclista e prossiga com o checkout."
                     >
                     </el-alert>
                     <el-alert
                        show-icon
                        :closable="false"
                        v-if="foundUser === true"
                        type="success"
                        effect="dark"
                        title="Ciclista encontrado. Prossiga com o checkout."
                     >
                     </el-alert>
                  </el-col>
               </el-row>

               <el-row :gutter="20">
                  <!-- Campo cpf -->
                  <el-col :span="24" :md="12">
                     <el-form-item :label="`${
                        isRequestedByOwner 
                        ? 
                        'Documento do ciclista' : docType == 'passport' ? 'Passaporte' : 'CPF'}`" prop="cpf">
                        <el-input
                           size="medium"
                           ref="cpfInput"
                           @clear="() => {
                              resetAllData()
                           }"
                           @keyup.native.enter="$refs['cpfInput'].blur()"
                           clearable
                           :disabled="!isRequestedByOwner || false"
                           v-mask="`${docType == 'passport' ? 'XXXXXXXXX' : '###.###.###-##'}`"
                           type="text"
                           v-model="userInfoForm.cpf"
                           :placeholder="`${isRequestedByOwner ? 'Digite o documento do ciclista' : 'Digite seu CPF'}`"></el-input>
                     </el-form-item>
                  </el-col>

                  <!-- Campo Email -->
                  <el-col :span="24" :md="12">
                     <el-form-item label="E-mail" prop="email">
                        <el-input
                           size="medium"
                           ref="mailInput"
                           @clear="() => {
                             resetAllData()
                           }"
                           @keyup.native.enter="$refs['mailInput'].blur()"
                           clearable
                           v-model="userInfoForm.email"
                           :disabled="!isRequestedByOwner || false"
                           :placeholder="`${isRequestedByOwner ? 'Digite o email do ciclista' : 'Digite seu email'}`"
                        ></el-input>
                     </el-form-item>
                  </el-col>
               </el-row>

               <!-- Nome e Sobrenome -->
               <el-row :gutter="20">
                  <el-col :span="24" :md="12">
                     <el-form-item label="Nome" prop="name">
                        <el-input
                           size="medium"
                           v-model.trim="userInfoForm.name"
                           :disabled="!isRequestedByOwner || foundUser === null || false"
                        ></el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="24" :md="12">
                     <el-form-item label="Sobrenome" prop="lastName">
                        <el-input
                           size="medium"
                           v-model="userInfoForm.lastName"
                           :disabled="!isRequestedByOwner || foundUser === null || false"
                        ></el-input>
                     </el-form-item>
                  </el-col>
               </el-row>


               <!-- Telefone -->
               <div style="font-size: 14px;color: #606266;" class="text-left d-block w-100 mb-2">* Telefone</div>
               <el-row :gutter="20" class="validate-phone">
                  <el-col :span="8" :sm="5">
                     <el-form-item>
                        <el-input
                           size="medium"
                           disabled
                           readonly
                           type="text"
                           :value="userInfoForm.countryCod"
                           v-model="countryCod"
                        ></el-input>
                     </el-form-item>
                  </el-col>

                  <el-col :span="16" :sm="9">
                     <el-form-item :error="`${!userInfoForm.verifiedPhone && !isRequestedByOwner ? 'Número não verificado' : ''}`">
                        <el-input
                           size="medium"
                           :disabled="checkout.loading || foundUser === null"
                           @change="changePhoneNumber"
                           v-mask="['(##) ####-####', '(##) #####-####']"
                           v-model="userInfoForm.phone"
                           placeholder="(99) 99999-9999"
                        ></el-input>
                     </el-form-item>
                  </el-col>
                  <el-col :span="24" :sm="10">
                     <el-form-item>
                        <el-button
                           @click="validateNumber"
                           :type="userInfoForm.verifiedPhone ? 'primary' : 'blue'"
                           :plain="userInfoForm.verifiedPhone"
                           size="mini"
                           class="text-uppercase font-weight-bold w-100 btn-validate"
                           :loading="loading.validateNumber"
                           :disabled=" this.loading.dataUser || userInfoForm.verifiedPhone || !userInfoForm.phone || checkout.loading"
                        >
                                       <span v-if="userInfoForm.verifiedPhone">
                                          <i class="el-icon-circle-check mr-1"></i> Número Verificado
                                       </span>
                           <span v-else>
                                          Verificar Número
                                       </span>

                        </el-button>
                     </el-form-item>
                  </el-col>
               </el-row>

               <el-collapse v-model="activeNames">
                  <el-collapse-item
                     title="Informações de endereço" name="1"
                  >

                     <el-row :gutter="20">
                        <el-col :span="24">
                           <!-- Zip Code - Filled in automatically via zip code | CEP - Preenchido automaticamente via cep -->
                           <el-form-item label="CEP" prop="cep">
                              <el-input
                                 size="medium"
                                 v-mask="'#####-###'"
                                 :maxlength="9"
                                 v-model="userInfoForm.cep"
                                 :clearable="true"
                                 @clear="() => {
                              this.clearAddress()
                              this.isValidCEP = null
                           }"
                                 :disabled="checkout.loading || foundUser === null"
                              >
                                 <i v-if="loading.cep" slot="suffix" class="el-input__icon el-icon-loading"></i>
                              </el-input>
                           </el-form-item>
                        </el-col>
                     </el-row>


                     <!-- Address | Endereço -->
                     <el-row :gutter="20">
                        <el-col :span="24" :sm="18">
                           <el-form-item label="Rua" prop="address">
                              <el-input size="medium" :disabled="foundUser === null"
                                        v-model="userInfoForm.address">
                                 <i v-if="loading.cep" slot="suffix" class="el-input__icon el-icon-loading"></i>
                              </el-input>
                           </el-form-item>
                        </el-col>
                        <el-col :span="24" :sm="6">
                           <el-form-item label="Número" prop="number">
                              <el-input size="medium" :disabled="foundUser === null"
                                        v-model="userInfoForm.number"></el-input>
                           </el-form-item>
                        </el-col>
                     </el-row>

                     <!-- Complement and district | Complemento e Bairro -->
                     <el-row :gutter="20">
                        <el-col :span="24" :sm="15">
                           <el-form-item label="Complemento" prop="complement">
                              <el-input size="medium" :disabled="foundUser === null"
                                        v-model="userInfoForm.complement"></el-input>
                           </el-form-item>
                        </el-col>
                        <el-col :span="24" :sm="9">
                           <el-form-item label="Bairro" prop="district">
                              <el-input size="medium" :disabled="foundUser === null"
                                        v-model="userInfoForm.district">
                                 <i v-if="loading.cep" slot="suffix" class="el-input__icon el-icon-loading"></i>
                              </el-input>
                           </el-form-item>
                        </el-col>
                     </el-row>

                     <!-- City and state auto fill via cep | Cidade e Estado com preenchimento automatico via cep -->
                     <el-row :gutter="20">
                        <el-col :span="24" :sm="12">
                           <el-form-item label="Cidade" prop="city">
                              <el-input size="medium" :disabled="foundUser === null" v-model="userInfoForm.city">
                                 <i v-if="loading.cep" slot="suffix" class="el-input__icon el-icon-loading"></i>
                              </el-input>
                           </el-form-item>
                        </el-col>
                        <el-col :span="24" :sm="12">
                           <el-form-item label="Estado" prop="state">
                              <el-input size="medium" :disabled="foundUser === null" v-model="userInfoForm.state">
                                 <i v-if="loading.cep" slot="suffix" class="el-input__icon el-icon-loading"></i>
                              </el-input>
                           </el-form-item>
                        </el-col>
                     </el-row>

                  </el-collapse-item>
               </el-collapse>



               <el-row :gutter="20">

                  <el-col :span="24">
                     <el-alert
                        v-if="!userInfoForm.verifiedPhone && !isRequestedByOwner"
                        title="Atenção: Você precisa verificar o seu número de telefone antes de prosseguir!"
                        class="mb-1 font-weight-bold"
                        type="error"
                        effect="dark"
                        :closable="false"
                     >
                     </el-alert>
                  </el-col>

                  <el-col :span="24" :lg="16">
                     <!-- Submit Pedido por anunciante -->
                        <el-button
                           v-if="isRequestedByOwner"
                           :loading="checkout.loading"
                           class="w-100 text-uppercase font-weight-bold mt-3"
                           :round="true"
                           size="default"
                           type="primary"
                           :disabled="isGoCheckout"
                           @click="submitInfoForm('userInfoForm')">
                           {{ checkout.loading ? 'Processando o pedido...' : 'Lançar pedido de locação' }}
                        </el-button>

                        <!-- Submit Ciclista -->
                        <el-button
                           v-if="!isRequestedByOwner"
                           :loading="checkout.loading"
                           class="w-100 text-uppercase font-weight-bold mt-3"
                           :round="true"
                           type="primary"
                           :disabled="!userInfoForm.verifiedPhone"
                           @click="submitInfoForm('userInfoForm')">
                           {{ checkout.loading ? 'Processando o pedido...' : 'Salvar e solicitar bicicleta' }}
                        </el-button>
                  </el-col>

                  <el-col :span="12" :lg="8" class="mt-4 mt-lg-0">
                     <el-button
                        :loading="checkout.loading"
                        class="w-100 text-uppercase font-weight-bold mt-3"
                        :round="true"
                        @click="closeCkeckoutModal">
                        Cancelar
                     </el-button>
                  </el-col>

               </el-row>

            </el-form>
         </b-card>
      </div>


      <el-dialog
         top="2vh"
         class="modal-page"
         :visible.sync="modalPage.politics"
         :destroy-on-close="true"
         :close-on-press-escape="true"
      >
         <Politics></Politics>

      </el-dialog>

      <!-- Código de Verificação de Telefone -->
      <el-dialog
         append-to-body
         title="Verificação de Número"
         :visible.sync="dialogValidateNumber"
         :before-close="dialogValidateNumberClose"
         width="40%"
         class="modal-responsive"
         :close-on-click-modal="false"
         :close-on-press-escape="true"
      >

         <span>Enviamos um código de 6 dígitos para o número informado. Por favor, digite o código abaixo:</span>

         <el-form
            :model="validateNumberCode"
            :rules="validateNumberCodeRules"
            ref="validateNumberCode"
            class="mt-4"
         >
            <el-form-item prop="code">
               <el-input
                  size="lg"
                  :disabled="loading.btnValidateCode || loading.btnResendCode"
                  v-model="validateNumberCode.code"></el-input>
            </el-form-item>

            <span class="dialog-footer d-flex justify-content-between">
             <el-button
                :loading="loading.btnValidateCode || loading.sendingCode"
                :disabled="loading.btnResendCode"
                type="blue"
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                @click="submitNumberCode('validateNumberCode')"
             >
                <span v-if="loading.sendingCode">Enviando Código...</span>
                <span v-else>Validar Código</span>

             </el-button>

             <el-button
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                :disabled="loading.btnValidateCode || loading.btnResendCode || btnValidateCodeResend"
                :loading="loading.btnResendCode"
                @click="reSendCode"
             >
                <span v-if=" loading.btnResendCode">Enviando...</span>
                <span v-else>Reenviar Código</span>

                <span v-if="countDown > 0"> ({{ countDown }})</span></el-button>

        </span>

         </el-form>
      </el-dialog>

   </div>

</template>

<script>

import { config } from "@/config";
import { calcAmountOrder, dailyNumber, onlyNumber } from "@/helpers";
import BikeImg from "@/helpers/GetBikeCover";
import isMail from "@/helpers/checkEmail";
import isCpf from "@/helpers/cpf";
import OrderService from '@/services/order.service';
import UserService from '@/services/user.service';
import Politics from "@/views/Politics";
import { BCard } from "bootstrap-vue";
import { mask } from 'vue-the-mask';
import { avatar, lock, shield } from '../media/Images';

export default {
   name: 'Checkout',
   components: {
      Politics,
      BCard
   },
   props: {
      loggedInUserInformation: {},
      selectedBike: {},
      isRequestedByOwner: null,
   },
   directives: {mask, 'b-card': BCard,},
   data() {
      return {
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         loading: {
            cep: false,
            validateNumber: false,
            btnValidateCode: false,
            btnResendCode: false,
            global: false,
            sendingCode: false,
            userData: false,
         },
         checkout: {
            step: 2,
            loading: false,
            title: '',
            desc: '',
            billingInfo: true,
            paymentInfo: false,
            success: false,
         },
         img: {
            shield,
            lock,
            avatar,
         },
         textAboutRate: 'Os custos de serviço estão inclusos, verifique seu extrato na Pedale após o faturamento.',
         changeDateTrigger: false,
         dateLocationPicker: '',
         bookingDates: {
            dateCheckin: '',
            dateCheckout: ''
         },
         openCheckoutModal: false,
         dataUser: null,
         userInfoForm: {
            name: '',
            _id: '',
            lastName: '',
            cpf: '',
            cep: '',
            address: '',
            number: '',
            complement: '',
            district: '',
            city: '',
            state: '',
            phone: '',
            verifiedPhone: null,
            countryCod: '+55',
            email: '',
            resources: {
               pushToken: ''
            }
         },
         userInfoFormRules: {
            name: [
               {required: true, message: 'Por favor, digite seu Nome', trigger: 'blur'},
            ],
            lastName: [
               {required: true, message: 'Por favor, digite seu Sobrenome', trigger: 'blur'},
            ],
            cpf: [
               {validator: this.checkCpf, trigger: 'blur'},
            ],
            email: [
               {validator: this.checkEmail, trigger: 'blur'},
            ],
            cep: [
               {validator: this.checkCep, trigger: 'change'},
            ],
            address: [
               {required: !this.isRequestedByOwner, message: 'Por favor, digite seu Endereço', trigger: 'blur'},
            ],
            number: [
               {required: !this.isRequestedByOwner, message: 'Digite o Número', trigger: 'blur'},
            ],
            complement: [
               {required: !this.isRequestedByOwner, message: 'Por favor, digite seu complemento', trigger: 'blur'},
            ],
            district: [
               {required: !this.isRequestedByOwner, message: 'Por favor, digite seu Bairro', trigger: 'blur'},
            ],
            city: [
               {required: !this.isRequestedByOwner, message: 'Por favor, digite seu Cidade', trigger: 'blur'},
            ],
            state: [
               {required: !this.isRequestedByOwner, message: 'Por favor, digite seu Estado', trigger: 'blur'},
            ]
         },
         paymentForm: {
            cardNumber: '',
            flag: '',
            holderName: '',
            expirationMonth: '',
            expirationYear: '',
            securityCode: '',
            savedCard: '',
         },
         paymentFormRules: {
            cardNumber: [
               {required: true, message: 'Por favor, digite o número do cartão', trigger: 'blur'},
            ],
            flag: [
               {required: true, message: 'Por favor, selecione a bandeira', trigger: 'blur'},
            ],
            holderName: [
               {required: true, message: 'Por favor, digite o Nome', trigger: 'blur'},
            ],
            expirationMonth: [
               {required: true, message: 'Por favor, selecione o mês', trigger: 'blur'},
            ],
            expirationYear: [
               {required: true, message: 'Por favor, selecione o ano', trigger: 'blur'},
            ],
            securityCode: [
               {required: true, message: 'Obrigatório!', trigger: 'blur'},
            ],
            savedCard: [
               {required: true, message: 'Selecione um cartão!', trigger: 'blur'},
            ],
         },
         newCard: false,
         cardFlagList: [
            {value: 'mastercard', label: 'MasterCard'},
            {value: 'visa', label: 'Visa'},
            {value: 'dinersclub', label: 'Diners Club'},
            {value: 'americanexpress', label: 'American Express'},
         ],
         monthDueList() {
            let item = [];
            for (let i = 1; i <= 12; ++i) {
               item.push({
                  value: i < 10 ? '0' + i : i,
                  label: i < 10 ? '0' + i : i
               })
            }
            return item;
         },
         yearDueList() {
            let actualYear = String(new Date().getFullYear());
            let limitlYear = +actualYear + 15;

            let item = [];

            for (let i = actualYear; i <= limitlYear; ++i) {
               item.push({
                  value: i,
                  label: i
               })
            }
            return item;
         },
         datePickerPtBr: {
            night: 'Diária',
            nights: 'Diárias',
            'day-names': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            'check-in': 'Buscar',
            'check-out': 'Entregar',
            'month-names': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
         },
         checkoutChanged: true,
         serviceCost: {
            ownerFeePedale: config.ownerFeePedale,
            cyclistFeePedale: config.cyclistFeePedale,
            cyclistFeeJuno: config.cyclistFeeJuno,
            cyclistFixedFeeJuno: config.cyclistFixedFeeJuno,
         },
         dataStored: null,
         availableDates: [],
         tempDates: [],
         allowedDates: [],
         endDate: '2050-01-01',
         startDate: this.$moment().format("YYYY-MM-DD"),
         successOrder: {
            _id: null,
            status: null,
            period: {
               checkin: null,
               checkout: null
            },
            amount: null,
            user: {
               firstName: null,
               lastName: null,
               email: null,
               phone: null,
               avatar: null
            },
            bike: {
               _id: null,
               name: null,
               city: null
            },
            orderN: null,
            owner: {}
         },
         avatarUri: '',
         hashCard: '',
         cards: [],
         modalPage: {
            politics: false
         },
         countryCod: '+55',
         dialogValidateNumber: false,
         validateNumberCode: {
            code: null
         },
         validateNumberCodeRules: {
            code: [
               {required: true, message: 'Por favor, digite o código', trigger: 'blur'},
            ],
         },
         btnValidateCodeResend: true,
         countDown: 0,
         firstCodeSubmission: false,
         isChangePhoneNumber: false,
         redirectedByNotVerifiedPhone: null,
         foundUser: null,
         isValidCpf: null,
         isValidEmail: null,
         isValidCEP: null,
         findCep: true,
         findBy: null,
         emailFound: '',
         cpfFound: '',
         convertOnlyNumber: onlyNumber,
         isSubmit: false,
         activeNames: []
      }
   },
   async mounted() {
      const isOwner = this.currentUser.user._id === this.selectedBike.user._id

      if (!isOwner) {
         //this.loading.userData = true
         this.isRequestedByOwner = false
         await this.getUserInfo(this.loggedInUserInformation)
         this.activeNames = ['1']

         /* if(this.infoUserIsOk) {
             await this.submitInfoForm('userInfoForm')
             this.loading.userData = false
          } else {
             this.loading.userData = false
          }*/

      }
      if (isOwner) {
         this.loading.userData = false
         this.resetForm('userInfoForm')
      }
/*      if (!isOpen) {
         setTimeout(() => {
            this.clearUserInfoCPFandMail()
         }, 200)
         setTimeout(() => {
            this.resetAllData()
         }, 200)
      }*/


    /*  if (this.bikeData._id) {

         this.bike._id = this.bikeData._id;
         this.bike.user = this.bikeData.user;
         this.bike.name = this.bikeData.info.name;
         this.bike.price = this.bikeData.info.dailyValue;
         this.bike.timeValue = this.bikeData.info.timeValue;
         this.bike.weekValue = this.bikeData.info.weekValue;
         this.bike.monthValue = this.bikeData.info.monthValue;
         this.bike.city = this.bikeData.address.city;
         this.bike.rateMetrics = this.bikeData.info.rateMetrics;
         this.bike.observations = this.bikeData.features.observation;
         this.bike.cover = this.getCover(this.bikeData.photos.coverPhoto);

         this.bookingDates = this.bikeData.bookingDates
         this.availableDates = this.bikeData.availableDates
      } else {
         // this.$router.push('/')
      }*/
      this.getPushToken()

   },
   methods: {

      // Obtém o token push do localStorage
      getPushToken() {
         this.userInfoForm.resources.pushToken = JSON.parse(localStorage.getItem('pushToken'))
      },

     /* hash(cardData) {

         /!*const payload = {
            cardNumber: this.formatCredCardNumber(cardData.cardNumber).trim(),
            expirationMonth: cardData.expirationMonth,
            expirationYear: cardData.expirationYear,
            flag: cardData.flag,
            holderName: cardData.holderName,
            savedCard: cardData.savedCard,
            securityCode: cardData.securityCode,
            importKey: ''
         }*!/

         //const token = process.env.VUE_APP_PUBLIC_TOKEN_PEDALE;


         // eslint-disable-next-line no-undef
         //const checkout = new DirectCheckout(token, process.env.NODE_ENV === "production");


         /!*checkout.getCardHash(payload, (s => {
            this.hashCard = s
         }), (error => {

            this.checkout.loading = false;


            switch (error.message) {
               case 'Invalid security code':
                  this.$message.error("Número de segurança inválido!");
                  break
               case 'Invalid card number':
                  this.$message.error("Número do cartão inválido!");
                  break
               case 'Invalid holder name':
                  this.$message.error("Nome do titular inválido!");
                  break
               case 'Invalid expire date':
                  this.$message.error("Data de expiração inválida");
                  break
               default:
                  this.$message.error(error.message);
            }
         }))*!/

      },*/

      async getUserInfo(res) {
         this.userInfoForm.name = res.firstName
         this.userInfoForm.lastName = res.lastName
         this.userInfoForm.email = res.email
         this.userInfoForm.cpf = res.additionalInformation.cpf
         this.userInfoForm.cep = res.address.cep
         this.userInfoForm.address = res.address.street
         this.userInfoForm.number = res.address.number
         this.userInfoForm.complement = res.address.complement
         this.userInfoForm.district = res.address.district
         this.userInfoForm.city = res.address.city
         this.userInfoForm.state = res.address.state
         this.userInfoForm.phone = res.additionalInformation.phone
         this.userInfoForm.verifiedPhone = res.additionalInformation.verifiedPhone
         this.foundUser = true

      },

      checkCpf(rule, value, callback) {

         const cpf = value ? onlyNumber(value) : null;

         if (!cpf) {
            this.isValidCpf = false
            return callback(new Error(`${this.isRequestedByOwner ? 'Informe o CPF do ciclista' : 'Por favor, informe seu CPF'}`));
         }

         if (cpf === this.cpfFound) {
            return callback()
         }

         if (this.findBy === 'email' && value !== this.cpfFound) {
            this.resetAllData()
            return callback()
         }

         if (this.isRequestedByOwner && this.findBy === null) {
            if (!isCpf(cpf)) {
               this.isValidCpf = false
               return callback(new Error('CPF Inválido'));
            }

            this.findBy = 'cpf'
            this.isValidCpf = true
            if (this.cpfFound && this.cpfFound !== value) {
               this.isValidCpf = false
               setTimeout(() => {
                  this.isValidCpf = true
                  this.cpfFound = ''
                  return callback()
               }, 200)
            }
            this.isValidCpf = false
            setTimeout(() => {
               this.isValidCpf = true
               this.cpfFound = ''
               return callback()
            }, 200)

         } else {
            return callback()
         }
      },

      checkEmail(rule, value, callback) {


         if (!value) {
            this.isValidEmail = false
            return callback(new Error(`${this.isRequestedByOwner ? 'Informe o email do ciclista' : 'Por favor, informe seu email'}`));
         }

         if (value === this.emailFound) {
            return callback()
         }

         const mail = isMail(value);

         if (this.isRequestedByOwner && this.findBy === null) {
            if (!mail) {
               this.isValidEmail = false
               return callback(new Error('E-mail Inválido'));
            } else {
               this.findBy = 'email'
               this.isValidEmail = true
               if (this.emailFound && this.emailFound !== value) {
                  this.isValidEmail = false
                  setTimeout(() => {
                     this.isValidEmail = true
                     this.emailFound = ''
                     return callback()
                  }, 200)
               }
               this.isValidEmail = false
               setTimeout(() => {
                  this.isValidEmail = true
                  this.emailFound = ''
                  return callback()
               }, 200)
            }
         } else {
            return callback()
         }
      },

      //Fecha o modal do Checkout e limpa todos os estados
      closeCkeckoutModal() {
         this.$confirm('Você tem certeza que quer fechar esta janela?')
            .then(() => {
               this.closePrecheckoutModal()
               this.resetForm('userInfoForm');
               this.resetForm('paymentForm');
               this.checkout.billingInfo = false;
               this.checkout.paymentInfo = false;
               this.checkout.success = false;
               this.checkout.loading = false;
               this.checkout.step = 0;
               this.loggedInUserInformation = {};
            })
      },

      //Metodo para resetar o formulário
      resetForm(formName) {
         const form = this.$refs[formName]
         if (form && form.resetFields()) {
            form.resetFields();
         }
      },

      //Envio do formulário Informações de Cobrança
      async submitInfoForm(formName) {
         this.isSubmit = true
         this.$refs[formName].validate((valid) => {
            if (valid) {

               /* Se for um pedido feito por um ciclista então retorna
               * apenas os dados do formulário via onCallBackIndo, que é capturado atualmente
               * no arquivo da bike. Na api do pedido, tem um método que salva as informações de endereço
               * do usuário.
               *  */
               if (!this.isRequestedByOwner) {
                  this.$emit('onCallBackIndo', this.userInfoForm);
               }

               /* Se for um pedido feito por um anunciante (isRequestedByOwner === true)
                * então podem ter dois cenários: ele está alugando para um ciclista já castrado
                * ou para um ciclista que ainda não tenha cadastro.
                * Se for o primeiro caso, ele precisa primeiro cadastrar o ciclista
                * depois retornar os dados e efetivar o pedido.
                * Se for no segundo caso, então só retorna os dados do ciclista.
                *  */

               // Caso seja pedido por anunciante e ciclista NÃO TENHA cadastro
               if (this.isRequestedByOwner && !this.userInfoForm._id) {
                  const payload = {
                     isRequestByOwner: true,
                     ownerId: this.currentUser.user._id,
                     firstName: this.userInfoForm.name,
                     lastName: this.userInfoForm.lastName,
                     email: this.userInfoForm.email,
                     additionalInformation: {
                        type: 'pf',
                        cpf: this.userInfoForm.cpf,
                        phone: this.userInfoForm.phone,
                        verifiedPhone: this.userInfoForm.verifiedPhone,
                     },
                     address: {
                        cep: this.userInfoForm.cep,
                        street: this.userInfoForm.address,
                        number: this.userInfoForm.number,
                        complement: this.userInfoForm.complement,
                        district: this.userInfoForm.district,
                        state: this.userInfoForm.state,
                        city: this.userInfoForm.city,
                     },
                  }

                  // Registra o usuário caso ele não exista, caso sucesso retorna dados via callback
                  UserService.registerUser(payload)
                     .then(res => {
                        if (res.data.user) {
                           this.$message({
                              message: "Ciclista cadastrado!",
                              type: 'success'
                           });

                           const payload = {
                              ...res.data.user,
                              cpf: this.userInfoForm.cpf,
                              phone: this.userInfoForm.phone,
                              verifiedPhone: this.userInfoForm.verifiedPhone,
                              address: this.userInfoForm.address,
                              cep: this.userInfoForm.cep,
                              city: this.userInfoForm.city,
                              complement: this.userInfoForm.complement,
                              district: this.userInfoForm.district,
                              number: this.userInfoForm.number,
                              state: this.userInfoForm.state,
                           }

                           // Após o registro, retorna os dados via Callback
                           this.$emit('onCallBackIndo', payload);
                        }
                  })
               }

               // Caso seja pedido por anunciante e ciclista JÁ TEM cadastro
               if (this.isRequestedByOwner && this.userInfoForm._id) {
                  // Apenas retorna os dados via Callback
                  this.$emit('onCallBackIndo', this.userInfoForm);
               }

               this.checkout.loading = false;

            } else {
               this.$message({
                  message: "Por favor, informe seu endereço completo!",
                  type: 'warning'
               });
               this.checkout.loading = false;
            }
         });
      },

      formatCredCardNumber(n) {
         const str = n
         const regex = /(\d+)/g;
         return str.split(/[0-9]+/).join("") + str.match(regex).join('')
      },

      orderModel(customerID) {
         return {
            customerID,
            isRequestByOwner: this.isRequestedByOwner,
            bike: this.selectedBike._id,
            amount: this.totalOrderAmount,
            period: {
               checkin: this.selectDatesQuery.dateCheckin,
               checkout: this.selectDatesQuery.dateCheckout,
            },
            userInfoForm: this.userInfoForm,
            billingAddress: {
               cep: this.userInfoForm.cep,
               street: this.userInfoForm.address,
               number: this.userInfoForm.number,
               complement: this.userInfoForm.complement,
               district: this.userInfoForm.district,
               city: this.userInfoForm.city,
               state: this.userInfoForm.state,
            }
         }
      },

      newOrder(obj) {
         OrderService.newOrder(obj)
            .then((response) => {
               this.$message({
                  message: response.data.message,
                  type: 'success'
               });
               this.checkout.billingInfo = false;
               setTimeout(() => {
                  //this.$emit('onSucessOrder', response);
                  /*this.checkout.loading = false;
                  this.checkout.success = true;
                  const res = response.data.data;
                  this.successOrder._id = res._id
                  this.successOrder.status = res.status
                  this.successOrder.period.checkin = res.period.checkin
                  this.successOrder.period.checkout = res.period.checkout
                  this.successOrder.amount = res.amount
                  this.successOrder.bike = res.bike
                  this.successOrder.orderN = res.orderN
                  this.successOrder.owner = res.owner*/
               }, 300)

            })
            .catch(() => {
               this.checkout.loading = false;
               this.closePrecheckoutModal()
            });
      },

      //Pega o CEP do ViaCep https://viacep.com.br/
      getCep(cep) {
         this.loading.cep = true;
         if (cep) {
            this.axios.get(`https://viacep.com.br/ws/${cep}/json/`).then((response) => {
               let res = response.data;
               if (res.erro) {
                  this.$message.error('CEP não encontrado!');
                  this.loading.cep = false;
                  return false
               }
               this.userInfoForm.address = res.logradouro;
               this.userInfoForm.district = res.bairro;
               this.userInfoForm.city = res.localidade;
               this.userInfoForm.state = res.uf;
               this.loading.cep = false;
            })
         }


      },

      //Faz validações no campo do CEP.
      checkCep(rule, value, callback) {

         if (this.isRequestedByOwner)
            return callback();

         if (!value) {
            this.isValidCEP = null
            return callback(new Error('Por favor, digite seu CEP'));
         }

         if (value.length !== 9) {
            this.userInfoForm.city = ''
            this.userInfoForm.state = ''
            this.userInfoForm.district = ''
            this.isValidCEP = false
            callback(new Error('Digite os 8 digitos do cep'));
         } else {
            this.isValidCEP = true
            callback();
         }
      },

      clearAddress() {
         this.userInfoForm.district = ''
         this.userInfoForm.city = ''
         this.userInfoForm.state = ''
      },

      getCover(uri) {
         return BikeImg.getCover(uri);
      },

      /*
      * Validação do telefone
      * */

      changePhoneNumber() {
         // this.editProfile = true
         this.isChangePhoneNumber = true
         this.userInfoForm.verifiedPhone = false
      },

      async validateNumber() {
         this.loading.validateNumber = true
         this.dialogValidateNumber = true

         if (this.countDown > 1) {
            return false
         } else {
            this.loading.sendingCode = true
            await this.sendCode()
         }

      },

      async sendCode() {
         try {

            const phone = this.countryCod + onlyNumber(this.userInfoForm.phone)

            await UserService.valNumberSendCode(phone)
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.loading.sendingCode = false
            this.countDown = 60
            this.countDownTimer()

            this.$message({
               message: "O Código Pedale foi enviado para o seu celular.",
               type: 'success'
            });

         } catch (e) {
            this.$message({
               message: "Solicitação indisponível no momento. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      async reSendCode() {
         try {
            this.loading.btnResendCode = true
            this.validateNumberCode.code = null
            this.loading.btnResendCode = true
            this.loading.sendingCode = true

            await this.sendCode()
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.countDown = 60
            this.countDownTimer()

         } catch (e) {
            this.$message({
               message: "Não foi possível enviar o código. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      submitNumberCode(formName) {
         this.$refs[formName].validate(async (valid) => {
            this.loading.btnValidateCode = true;

            if (valid) {

               try {


                  await UserService.valNumberVerifyCode(this.validateNumberCode.code)

                  this.$message({
                     message: "Número verificado com sucesso! Obrigado.",
                     type: 'success'
                  });

                  this.userInfoForm.verifiedPhone = true
                  this.loading.btnValidateCode = false
                  this.loading.validateNumber = false
                  this.dialogValidateNumber = false
                  this.redirectedByNotVerifiedPhone = true

                  await UserService.savePhoneNumber(this.userInfoForm.phone)

               } catch (e) {
                  this.loading.btnValidateCode = false;
                  this.loading.validateNumber = false
               }

            } else {
               this.$message({
                  message: "Por favor, informe o código!",
                  type: 'warning'
               });
               this.loading.btnValidateCode = false;
               return false;
            }
         });
      },

      dialogValidateNumberClose() {
         this.loading.validateNumber = false
         this.dialogValidateNumber = false
         this.btnValidateCodeResend = true
         setTimeout(() => {
            if (!this.btnValidateCodeResend) {
               this.countDown = 60
            }

         }, 100)
      },

      countDownTimer() {
         if (this.countDown > 0) {
            setTimeout(() => {
               this.countDown -= 1
               this.countDownTimer()
            }, 1000)
         } else {
            this.btnValidateCodeResend = false
         }
      },

      clearUserInfo() {
         this.userInfoForm.name = ''
         this.userInfoForm._id = ''
         this.userInfoForm.lastName = ''
         this.userInfoForm.cep = ''
         this.userInfoForm.address = ''
         this.userInfoForm.complement = ''
         this.userInfoForm.number = ''
         this.userInfoForm.district = ''
         this.userInfoForm.city = ''
         this.userInfoForm.state = ''
         this.userInfoForm.phone = ''
         this.userInfoForm.verifiedPhone = null
         this.emailFound = ''
         this.cpfFound = ''
      },

      clearUserInfoCPFandMail () {
         this.userInfoForm.cpf = ''
         this.userInfoForm.email = ''
      },

      resetAllData() {
         this.foundUser = null
         this.isValidCpf = null
         this.isValidEmail = null
         this.isValidCEP = null
         this.findCep = true
         this.findBy = null
         this.isSubmit = false

         this.clearUserInfo()

         setTimeout(() => {
            this.clearUserInfoCPFandMail()
            this.resetForm('userInfoForm')
         }, 200)
      },

      async findUser() {
         const localEmail = this.userInfoForm.email
         const localCpf = this.userInfoForm.cpf
         this.resetForm('userInfoForm')
         this.userInfoForm.email = localEmail
         this.userInfoForm.cpf = localCpf
         this.loading.userData = true
         let payload
         if (this.isValidCpf === true || this.isValidEmail === true) {
            payload = {
               cpf: this.findBy === 'cpf' ? this.userInfoForm.cpf : '',
               email: this.findBy === 'email' ? this.userInfoForm.email : '',
            }
         }
         await UserService.getUser(payload).then((v) => {
            this.foundUser = true
            const { user } = v.data
            this.userInfoForm._id = user._id
            this.userInfoForm.name = user.firstName
            this.userInfoForm.lastName = user.lastName
            this.userInfoForm.cep = user.address.cep
            this.userInfoForm.address = user.address.street
            this.userInfoForm.complement = user.address.complement
            this.userInfoForm.number = user.address.number
            this.userInfoForm.district = user.address.district
            this.userInfoForm.city = user.address.city
            this.userInfoForm.state = user.address.state
            this.userInfoForm.phone = user.additionalInformation.phone
            this.userInfoForm.verifiedPhone = user.additionalInformation.verifiedPhone
            this.emailFound = user.email
            this.cpfFound = onlyNumber(user.additionalInformation.cpf)

            if (this.findBy === 'email') {
               this.userInfoForm.cpf = user.additionalInformation.cpf
            }

            if (this.findBy === 'cpf') {
               this.userInfoForm.email = user.email
            }


            this.loading.userData = false
            this.findBy = null

            // Usado para não buscar o CEP caso encontre o usuário. Porém habilita a busca após 2 segundos.
            this.findCep = false
            setTimeout(() => {
               this.findCep = true
            }, 1000)
         })
            .catch(() => {
               this.loading.userData = false
               this.foundUser = false
               this.findBy = null
               this.findCep = true
               this.clearUserInfo()
            })
      },

      infoUserIsOk() {
         return !!(this.userInfoForm.cep &&
            this.userInfoForm.address &&
            this.userInfoForm.number &&
            this.userInfoForm.city &&
            this.userInfoForm.state &&
            this.userInfoForm.district)
      },

      closePrecheckoutModal() {
         this.$emit('closeModal', true);
      },
   },

   computed: {
    docType: function () {
        return this.loggedInUserInformation.additionalInformation.type
    } ,
      dailyNumber: function () {
         return dailyNumber(this.selectDatesQuery.dateCheckin, this.selectDatesQuery.dateCheckout);
      },

      timeNumber: function () {
         // Calcula quantas horas o cliente selecionou, em pedalada por hora sob-demanda.
         const startTime = this.$moment(this.startHourRental, 'HH:mm');
         const endTime = this.$moment(this.endHourRental, 'HH:mm');
         const duration = this.$moment.duration(endTime.diff(startTime));
         return duration.asHours()

      },

      currentUser() {
         return this.$store.state.auth.user;
      },

      totalOrderAmount() {
         return calcAmountOrder(dailyNumber(this.selectDatesQuery.dateCheckin, this.selectDatesQuery.dateCheckout), this.selectedBike.price)

      },

      selectDatesQuery() {
         return this.$store.state.selectDates.dates;
      },

      isGoCheckout: function () {
         return this.isRequestedByOwner
            && !this.userInfoForm.cpf
            || !this.userInfoForm.email
            || !this.userInfoForm.phone
      },

      checkIsSendBySubmit: function () {
         return this.isSubmit
      },

      leaseModality: function () {
         switch (this.$store.state.selectDates.options.leaseModality) {
            case 'onDemand':
               return 'Sob demanda'
            case 'signature':
               return 'Assinatura'
            default:
               return 'Sob demanda'
         }
      },

      typeOfLeasePeriod: function () {
         return this.$store.state.selectDates.options.typeOfLeasePeriod
      },

      typeOfLeasePeriodFormated: function () {
         switch (this.$store.state.selectDates.options.typeOfLeasePeriod) {
            case 'perHour':
               return 'Por hora'
            case 'daily':
               return 'Por dia'
            case 'perWeek':
               return 'Por semana'
            case 'monthly':
               return 'Por mês'
            default:
               return 'Por dia'
         }
      },

      numberOfMonthsOfLease: function () {
         return this.$store.state.selectDates.options.numberOfMonthsOfLease
      },

      numberOfRentalWeeks: function () {
         return this.$store.state.selectDates.options.numberOfRentalWeeks
      },

      daySelectedForHourlyRental: function () {
         return this.$store.state.selectDates.options.daySelectedForHourlyRental
      },

      startHourRental: function () {
         return this.$store.state.selectDates.options.startHourRental
      },

      endHourRental: function () {
         return this.$store.state.selectDates.options.endHourRental
      },

      //Adiciona a nova data conforme selecionada no datapicker.
      /* newDateCheckin: function () {
           let newDate = [];
           if (this.dateLocationPicker.length) {
               newDate = this.dateLocationPicker;
           }
           return newDate;
       },*/
   },
   watch: {
      isValidCpf: async function (isValid) {

         if (isValid && this.findBy === 'cpf' && !this.checkIsSendBySubmit) {
            await this.findUser()
         }
      },

      isValidEmail: async function (isValid) {
         if (isValid && this.findBy === 'email' && !this.checkIsSendBySubmit) {
            await this.findUser()
         }
      },

      isValidCEP: async function (isValid) {
         if (isValid && this.findCep && !this.userInfoForm.city) {
            await this.getCep(this.userInfoForm.cep)
         }
      },

      'userInfoForm.cpf': function (newCpf, oldCpf) {
         const n = onlyNumber(newCpf)
         const o = onlyNumber(oldCpf)
         if (this.findBy === 'cpf') {
            if (!n || n !== o) {
               this.resetAllData()
            }
         }
      },

      'userInfoForm.email': function (newEmail) {
         if (this.findBy === 'email') {
            if (!newEmail || newEmail !== newEmail) {
               this.resetAllData()
            }
         }
      },

      //Assiste a variável billingInfo (Booleano). Se for true, altera o título
      'checkout.billingInfo': function (_new) {
         if (_new) {
            this.checkout.title = `${this.isRequestedByOwner ? 'Informações do Ciclista' : 'Informações de Pessoais'}`;
            this.checkout.desc = `${this.isRequestedByOwner ? '' : 'Confira seus dados pessoais para essa reserva'}`;

         }
      },

      //Assiste a variável paymentInfo (Booleano). Se for true, altera o título
      'checkout.paymentInfo': function (_new) {
         if (_new) {
            this.checkout.title = 'Informações de Pagamento';
            this.checkout.desc = 'Informe seus dados do Cartão de Crédito';
            this.checkout.step = 1
         }
      },

      //Assiste a variável success (Booleano). Se for true, altera o título
      'checkout.success': function (_new) {
         if (_new) {
            this.checkout.title = `${this.isRequestedByOwner ? 'O pedido foi efetivado com sucesso!' : 'O seu pedido foi efetivado com sucesso!'}`;
            this.checkout.desc = `${this.isRequestedByOwner
               ? 'O pedido de reserva foi efetivado e o ciclista já foi notificado. O resumo do pedido foi enviado para o seu e-mail!'
               : 'O seu pedido de reserva foi efetivado e o anfitrião já foi notificado. Os detalhes desta reserva foram enviados para o seu e-mail.'}`;
            this.checkout.step = 3
         }
      },

      //Usado como helper para evitar contagem de datas ao atualizar o calenrário.
      'bookingDates.dateCheckout': function () {
         this.checkoutChanged = true;
      },

      'successOrder.user.avatar': function (n) {
         const imgDir = n.destination;
         if (n.filename) {
            this.avatarUri = `${this.baseUrl}/${imgDir}/${n.filename}`;
         }
      },

      hashCard: function (hash) {
         if (hash) {
            this.newOrder(this.orderModel(hash))
         }
      },


   }
};
</script>

<style lang="scss">

.el-collapse-item__header {
   font-weight: bold;
   font-size: 1rem;
   color: #525252;
}
.modal-info-user {
   .card-body {
      padding-top: 10px;
   }

   .el-form-item--mini .el-form-item__label {
      line-height: 15px;
   }
}
.checkout .p-input.sub-title {
   display: none;
}

.site.checkout .fake-input-date .datepicker__clear-button, .my-reservations .fake-input-date .datepicker__clear-button {
   border: 1px solid #dadada;
   border-radius: 5px;
   height: 36px;
   width: 36px;
   padding: 4px 11px !important;
   line-height: 29px;
   top: -6px;
   right: -150px;
   zoom: 0.9;

   @media only screen and (min-width: 768px) {
      top: 0;
   }
}
</style>
